var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav',{ref:"cntFolhas",staticClass:"cnt-folhas tam_a4"},[_c('div',{staticClass:"folha",attrs:{"contenteditable":""}}),_vm._v(" "),_c('div',{staticClass:"folha",attrs:{"contenteditable":""}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-23153f60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/models/template/index.vue
// module id = null
// module chunks = 